
      var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIcon58Whatsapp2X = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 116,
  height: 116,
  viewBox: "0 0 58 58",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "m14.015 44.11.377-.102 5.564-1.771a.7.7 0 0 1 .65.08 16.416 16.416 0 0 0 24.46-18.667 16.462 16.462 0 0 0-32.148 4.57 15.8 15.8 0 0 0 2.936 9.63.49.49 0 0 1 .08.526c-.217.582-.4 1.142-.594 1.748l-1.325 3.987zM9 49c.149-.434.274-.834.411-1.222 1.017-2.982 2.022-5.975 3.039-8.957a.51.51 0 0 0 0-.514A19.42 19.42 0 0 1 24.125 9.736c9.83-2.761 20.137 2.467 23.716 12.03 3.408 9.26-.67 19.604-9.481 24.047a19.42 19.42 0 0 1-18.21-.103.67.67 0 0 0-.571 0L9.309 49z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.314 19.64h.343a.96.96 0 0 1 1.085.697c.537 1.268 1.074 2.525 1.588 3.804.08.238.08.494 0 .732a5.2 5.2 0 0 1-1.142 1.622c-.389.422-.411.582-.114 1.085a13.06 13.06 0 0 0 6.58 5.575c.3.179.69.088.88-.206q.753-.891 1.473-1.816c.309-.389.537-.514 1.005-.309.823.343 1.623.72 2.434 1.143l1.599.777a.64.64 0 0 1 .388.64 3.67 3.67 0 0 1-1.873 3.46 5.26 5.26 0 0 1-4.33.63 19.7 19.7 0 0 1-6.694-3.12 23.5 23.5 0 0 1-4.57-4.946 12.2 12.2 0 0 1-1.828-3.427 5.45 5.45 0 0 1 1.428-5.815 1.95 1.95 0 0 1 1.748-.526",
  fill: "var(--theme-primary, #810ea9)"
}))));

      const __svgRaw = "<svg width=\"116\" height=\"116\" viewBox=\"0 0 58 58\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\"><path d=\"m14.015 44.11.377-.102 5.564-1.771a.7.7 0 0 1 .65.08 16.416 16.416 0 0 0 24.46-18.667 16.462 16.462 0 0 0-32.148 4.57 15.8 15.8 0 0 0 2.936 9.63.49.49 0 0 1 .08.526c-.217.582-.4 1.142-.594 1.748l-1.325 3.987zM9 49c.149-.434.274-.834.411-1.222 1.017-2.982 2.022-5.975 3.039-8.957a.51.51 0 0 0 0-.514A19.42 19.42 0 0 1 24.125 9.736c9.83-2.761 20.137 2.467 23.716 12.03 3.408 9.26-.67 19.604-9.481 24.047a19.42 19.42 0 0 1-18.21-.103.67.67 0 0 0-.571 0L9.309 49z\" fill=\"#000\"/><path d=\"M23.314 19.64h.343a.96.96 0 0 1 1.085.697c.537 1.268 1.074 2.525 1.588 3.804.08.238.08.494 0 .732a5.2 5.2 0 0 1-1.142 1.622c-.389.422-.411.582-.114 1.085a13.06 13.06 0 0 0 6.58 5.575c.3.179.69.088.88-.206q.753-.891 1.473-1.816c.309-.389.537-.514 1.005-.309.823.343 1.623.72 2.434 1.143l1.599.777a.64.64 0 0 1 .388.64 3.67 3.67 0 0 1-1.873 3.46 5.26 5.26 0 0 1-4.33.63 19.7 19.7 0 0 1-6.694-3.12 23.5 23.5 0 0 1-4.57-4.946 12.2 12.2 0 0 1-1.828-3.427 5.45 5.45 0 0 1 1.428-5.815 1.95 1.95 0 0 1 1.748-.526\" fill=\"var(--theme-primary, #810ea9)\"/></g></svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icon-58-whatsapp@2x.2ec10f4720c90163adb348f83f916c4f.svg"),
        {
          React: SvgIcon58Whatsapp2X,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      